import {
  Autocomplete as MuiAutocomplete,
  AutocompleteProps as MuiAutocompleteProps,
} from '@mui/material';
import clsx from 'clsx';

/**
 * Autocomplete Component
 *
 * This is a wrapper around MUI's `Autocomplete` component that allows for
 * additional customization while maintaining the existing MUI props.
 *
 */

const Autocomplete = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>(
  props: MuiAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
) => {
  return (
    <MuiAutocomplete
      {...props}
      classes={{
        ...props.classes,
        inputRoot: clsx(
          props.classes?.inputRoot,
          '[&.Mui-error_fieldset]:!border-error-primary',
        ),
      }}
    />
  );
};

export default Autocomplete;
